export default __webpack_public_path__ + "static/media/atcoder.d57b40ed.png";